import { DentalOfficeShiftCard } from '@tempmee/react-blocks';
import { InviteProfessionalPopup } from '~/commonComponents/InviteProfessional/Popup';
import { CancelShiftConfirmPopup } from '~/components/shared/CancelShiftConfirmPopup';
import { useScheduleJobCard } from './useScheduleJobCard';

export const JobCard = ({ job, onCardClick }) => {
  const {
    cardData,
    isInterview,
    handleInvite,
    menuItems,
    onReportIncident,
    incidentReported,
    canReportIncident,
    rebookPopup,
    isInvitePopupOpen,
    closeInvitePopup,
    isCancelPopupOpen,
    closeCancelPopup,
    confirmCancel,
    isCancelPending,
  } = useScheduleJobCard(job);

  return (
    <>
      <DentalOfficeShiftCard
        {...cardData}
        onMessage={handleInvite}
        menuItems={menuItems}
        onReportIncident={onReportIncident}
        incidentReported={incidentReported}
        canReportIncident={canReportIncident}
        onCardClick={() => onCardClick(job)}
        data-cy="schedule-shift-card"
      />

      {rebookPopup}

      {isInvitePopupOpen && (
        <InviteProfessionalPopup
          isOpen={isInvitePopupOpen}
          isRefetchJob
          jobId={job?.id}
          profession={job?.profession}
          officeId={job?.offer_owner?.id}
          onClose={closeInvitePopup}
          trackingSource="Schedule List"
        />
      )}

      {isCancelPopupOpen && (
        <CancelShiftConfirmPopup
          isInterview={isInterview}
          date={job?.local_date}
          isPending={isCancelPending}
          onClose={closeCancelPopup}
          onConfirm={confirmCancel}
        />
      )}
    </>
  );
};
